import useGetSyncPromise from './useGetSyncPromise';
import {SyncPromise} from '../abstractGetSyncPromise';

export default function useSyncPromise<T>(promise: Promise<T>, defaultValue?: T): SyncPromise<T> {
    const getSyncPromise = useGetSyncPromise();
    return getSyncPromise(promise, defaultValue);
}
